import React from 'react';

// Components

const Construction = props => (
  <div className="construction">
    <div className="construction-notification">
      <h1>401</h1>
      <h2>Page unauthorized for launch until all systems are GO</h2>
    </div>
  </div>
)

export default Construction;



// WEBPACK FOOTER //
// ./src/pages/Construction.js